import React, {useEffect, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {Grid, Box} from '@mui/material';
import apiCall, {setUserToken} from '@/utils/api';
import Loader from '@/shared/Loader';
import VolunteerActivation from 'src/containers/FdcMilanoVolunteers/Charts/VolunteerActivation';
import TrainingActivities from 'src/containers/FdcMilanoVolunteers/Charts/TrainingActivities';
import SatisfactionLevelActivities from 'src/containers/FdcMilanoVolunteers/Charts/SatisfactionLevelActivities';
import SatisfactionActivitiesCarried from 'src/containers/FdcMilanoVolunteers/Charts/SatisfactionActivitiesCarried';
import {ISubmissionProps} from '@/containers/FdcMilanoVolunteers/resources/submission';

import './styles.scss';

const FdcMilanoVolunteers = () => {
    const [searchParams] = useSearchParams();
    const container = searchParams.get('container_id');
    const volunteersSurvey = searchParams.get('volunteers_survey');
    const volunteerSatisfactionSurvey = searchParams.get('volunteer_satisfaction_survey');

    setUserToken(searchParams.get('token') || '')

    const [loading, setLoading] = useState<boolean>(true);
    const [submissions, setSubmissions] = useState<ISubmissionProps[]>([]);
    const [volunteerSatisfactionSubmissions, setVolunteerSatisfactionSubmissions] = useState<ISubmissionProps[]>([]);

    const getSurvey = async () => {
        try {
            const responses = await apiCall({
                url: `containers/${container}/submissions`,
                params: {
                    survey_id: volunteersSurvey,
                    completed: 1,
                    additional_data: false,
                },
            });
            const responsesVolunteerSatisfaction = await apiCall({
                url: `containers/${container}/submissions`,
                params: {
                    survey_id: volunteerSatisfactionSurvey,
                    completed: 1,
                    additional_data: false,
                },
            });

            setSubmissions(responses.data.submissions);
            setVolunteerSatisfactionSubmissions(responsesVolunteerSatisfaction.data.submissions);
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        getSurvey().then(() => setLoading(false));
    }, []);

    return (
        <Box p={2}>
            {
                !loading && (
                    <>
                        <Grid container rowSpacing={1} columnSpacing={{xs: 1, sm: 2, md: 3}}>
                            <Grid item xs={6}>
                                <VolunteerActivation
                                    submissions={submissions}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <TrainingActivities
                                    submissions={volunteerSatisfactionSubmissions}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <SatisfactionLevelActivities
                                    submissions={volunteerSatisfactionSubmissions}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <SatisfactionActivitiesCarried
                                    submissions={volunteerSatisfactionSubmissions}
                                />
                            </Grid>
                        </Grid>
                    </>
                )
            }
            {
                loading && (
                    <Box className='loader-container'>
                        <Loader size={60}/>
                    </Box>
                )
            }
        </Box>
    )
}

export default FdcMilanoVolunteers;